let store;
let initialize;
export const setData = data => {
	store = data;
};
export const getData = () => {
	return store;
};
export const setInit = init => {
	initialize = init;
};
export const getInit = () => {
	return initialize;
};
